import { AgreementsExpirationReport } from './../_models/AgreementsExpirationReport';
import { ReportService } from './../_services/report.service';
import { AlertifyService } from './../_services/alertify.service';
import { Observable ,  of } from 'rxjs';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError } from '../../../node_modules/rxjs/operators';

@Injectable()
export class AgreementsExpReportResolver implements Resolve<AgreementsExpirationReport[]> {
    // pageNumber = 1;
    // pageSize = 25;

    constructor(private reportService: ReportService, private router: Router, private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<AgreementsExpirationReport[]> {
        let params: any = {};
        params.Export = "true";
        return this.reportService.GetAgreementsExpiration(null, null, params).pipe(
            catchError(error => {
                this.alertify.error(error.status + ': ' + error.statusText);
                this.router.navigate(['/dashboard']);
                return of(null);
            })
        );
    }
}
